export default __webpack_public_path__ + "static/media/googleplay.4801e8ea.svg";